/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./j-markup-table.vue?vue&type=template&id=ad7c5292&scoped=true"
import script from "./j-markup-table.vue?vue&type=script&lang=js"
export * from "./j-markup-table.vue?vue&type=script&lang=js"
import style0 from "./j-markup-table.vue?vue&type=style&index=0&id=ad7c5292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7c5292",
  null
  
)

export default component.exports
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QMarkupTable,QCheckbox,QTr,QInnerLoading});
